"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeStylesheets = void 0;
var tslib_1 = require("tslib");
var core_1 = require("@stylable/core");
var postcss_1 = require("postcss");
var css_shorthands_1 = require("./css-utils/css-shorthands");
function getShorthandProps(_prop) {
    var shortHands = css_shorthands_1.cssShorthandMap;
    return shortHands[_prop] ? shortHands[_prop].computed : [];
}
var createDeclarationMap = function (rule) {
    var declarations = {};
    rule.walkDecls(function (decl) {
        var e_1, _a;
        try {
            // removing redundant long-hand declarations
            for (var _b = tslib_1.__values(getShorthandProps(decl.prop)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var unreachableLongHandDecl = _c.value;
                delete declarations[unreachableLongHandDecl];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        declarations[decl.prop] = decl;
        decl.remove();
    });
    return declarations;
};
function mergeDecls(rule) {
    var declarations = createDeclarationMap(rule);
    var finalRule = rule.clone({ nodes: Object.values(declarations) });
    return finalRule;
}
function mergeStylesheets(destination, source) {
    var filterImports = function (node) {
        return (node.type === 'rule' && node.selector === ':import') || (node.type === 'atrule' && node.name === 'st-import');
    };
    var astA = (0, postcss_1.parse)(destination);
    var astB = (0, postcss_1.parse)(source);
    var allParsedImports = astB.nodes.filter(filterImports).map(function (rule) {
        var parsed = (0, core_1.parseStylableImport)(rule, '*', new core_1.Diagnostics());
        rule.remove();
        return parsed;
    });
    var diagnostics = (0, core_1.ensureStylableImports)(astA, allParsedImports, { newImport: 'none' }).diagnostics;
    if (diagnostics.reports.length > 0) {
        throw new Error("Error merging :import rule, diagnostics: ".concat(diagnostics.reports));
    }
    return merge(astA, astB).toString();
}
exports.mergeStylesheets = mergeStylesheets;
function merge(destination, source) {
    mergeNodes(destination, source);
    removeOverriddenDecls(destination);
    return destination;
}
function mergeNodes(destination, source) {
    var e_2, _a, e_3, _b, e_4, _c;
    var i = destination.nodes.length;
    var handled = new Set();
    while (i--) {
        var node = destination.nodes[i];
        if (node.type === 'rule') {
            var nodesToMerge = getAllMatchingNode(source.nodes, node);
            try {
                for (var nodesToMerge_1 = (e_2 = void 0, tslib_1.__values(nodesToMerge)), nodesToMerge_1_1 = nodesToMerge_1.next(); !nodesToMerge_1_1.done; nodesToMerge_1_1 = nodesToMerge_1.next()) {
                    var nodeToMerge = nodesToMerge_1_1.value;
                    handled.add(nodeToMerge);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (nodesToMerge_1_1 && !nodesToMerge_1_1.done && (_a = nodesToMerge_1.return)) _a.call(nodesToMerge_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            node.replaceWith(mergeDecls(appendToFirst(tslib_1.__spreadArray([node], tslib_1.__read(nodesToMerge), false))));
        }
        else if (node.type === 'atrule') {
            var nodesToMerge = getAllMatchingNode(source.nodes, node);
            try {
                for (var nodesToMerge_2 = (e_3 = void 0, tslib_1.__values(nodesToMerge)), nodesToMerge_2_1 = nodesToMerge_2.next(); !nodesToMerge_2_1.done; nodesToMerge_2_1 = nodesToMerge_2.next()) {
                    var nodeToMerge = nodesToMerge_2_1.value;
                    handled.add(nodeToMerge);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (nodesToMerge_2_1 && !nodesToMerge_2_1.done && (_b = nodesToMerge_2.return)) _b.call(nodesToMerge_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            nodesToMerge.reduce(function (a, b) { return mergeNodes(a, b); }, node);
        }
    }
    try {
        for (var _d = tslib_1.__values(source.nodes), _e = _d.next(); !_e.done; _e = _d.next()) {
            var node = _e.value;
            if (!handled.has(node)) {
                destination.append(node);
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_c = _d.return)) _c.call(_d);
        }
        finally { if (e_4) throw e_4.error; }
    }
    return destination;
}
function removeOverriddenDecls(nodesA, _a) {
    // assumes no two selector from the same variant on applied on the same node
    var _b = _a === void 0 ? {} : _a, _c = _b.unsafeMergeAll, unsafeMergeAll = _c === void 0 ? false : _c;
    var rules = new Set();
    nodesA.walkRules(function (current) {
        var e_5, _a, e_6, _b;
        var currentDecls = current.nodes.filter(function (node) { return node.type === 'decl'; });
        var currentDeclProps = new Set(currentDecls.map(function (decl) { return decl.prop; }));
        try {
            for (var rules_1 = tslib_1.__values(rules), rules_1_1 = rules_1.next(); !rules_1_1.done; rules_1_1 = rules_1.next()) {
                var rule = rules_1_1.value;
                if (isSamePath(current, rule)) {
                    if (unsafeMergeAll) {
                        current.prepend(rule.nodes);
                    }
                    else {
                        try {
                            for (var _c = (e_6 = void 0, tslib_1.__values(rule.nodes.slice())), _d = _c.next(); !_d.done; _d = _c.next()) {
                                var node = _d.value;
                                if (node.type === 'decl' && currentDeclProps.has(node.prop) /** TODO: handle shorthand */) {
                                    node.remove();
                                }
                            }
                        }
                        catch (e_6_1) { e_6 = { error: e_6_1 }; }
                        finally {
                            try {
                                if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                            }
                            finally { if (e_6) throw e_6.error; }
                        }
                    }
                    if (removeNodeAndEachParentIfEmpty(rule)) {
                        rules.delete(rule);
                    }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (rules_1_1 && !rules_1_1.done && (_a = rules_1.return)) _a.call(rules_1);
            }
            finally { if (e_5) throw e_5.error; }
        }
        rules.add(current);
    });
}
function removeNodeAndEachParentIfEmpty(node) {
    if (!node) {
        return;
    }
    var nodes = node.nodes.filter(function (node) { return node.type !== 'comment'; });
    var parent = node.parent; // before removing capture parent
    if (nodes.length === 0) {
        node.remove();
        if (parent && parent.type !== 'root') {
            removeNodeAndEachParentIfEmpty(parent);
        }
        return true;
    }
    return false;
}
function isSamePath(nodeA, nodeB) {
    if (nodeA.type !== nodeB.type) {
        return false;
    }
    switch (nodeA.type) {
        case 'rule':
            nodeB = nodeB;
            if (nodeA.selector !== nodeB.selector) {
                return false;
            }
            break;
        case 'atrule':
            nodeB = nodeB;
            if (nodeA.name !== nodeB.name || nodeA.params !== nodeB.params) {
                return false;
            }
            break;
        case 'root':
            return true;
    }
    if (nodeA.parent) {
        nodeB = nodeB;
        var a = nodeA.parent;
        var b = nodeB.parent;
        return nodeB.parent ? isSamePath(a, b) : false;
    }
    return false;
}
function appendToFirst(rules) {
    return rules.reduce(function (a, b) {
        a.append(b.nodes);
        return a;
    });
}
function getAllMatchingNode(b, node) {
    var result = [];
    result = b.filter(function (bNode) {
        if (node.type === 'rule' && bNode.type === 'rule') {
            return node.selector === bNode.selector;
        }
        else if (node.type === 'atrule' && bNode.type === 'atrule') {
            return node.name === bNode.name && node.params === bNode.params;
        }
        return false;
    });
    return result;
}
//# sourceMappingURL=merge-stylesheets.js.map